"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const react_redux_1 = require("react-redux");
const app_1 = require("ducks/app");
const orders_1 = require("ducks/orders");
const orders_2 = require("selectors/orders");
const profile_1 = require("selectors/profile");
// Local Imports
const index_1 = __importDefault(require("./index"));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const mapStateToProps = (state) => {
    return {
        orders: (0, orders_2.orders)(state),
        ordersLoaded: (0, orders_2.ordersLoaded)(state),
        profile: (0, profile_1.getCurrentProfile)(state),
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = { loadOrders: orders_1.loadOrders, appFeedbackMessageSuccess: app_1.appFeedbackMessageSuccess };
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
